module.exports = __webpack_public_path__ + "static/media/main.2b065b17.jpg";